import homeMobileMap from "../assets/game/home-mobile.png";
import restaurantMobileBg from "../assets/game/restaurent_bg mobile.png";

export const unhealthyGameConfig = {
  title: "Escape From An Unhealthy Lifestyle",
  introVideo: "/unhealthy-game/img/new_version.mp4",
  /** Same as legacy `intro.php` (`rest_bg2.jpg`). */
  introBackground: "/unhealthy-game/img/rest_bg2.jpg",
  logoGif: "/unhealthy-game/img/logo.gif",
  mapBackgroundDesktop: "/unhealthy-game/img/home.jpg",
  mapBackgroundMobile: homeMobileMap,
  mapBackground: "/unhealthy-game/img/home.jpg",
  /** Sum of per-stage max scores (yoga + restaurants + gym + basketball + swimming + walking + supermarket). */
  maxScore: 218,
};

/**
 * Click targets aligned with `unhealthy-lifestyle-php/mainpage.php` (div#bchild_*, #rchild_*).
 * Labels are for accessibility only — the map image/SVG already shows place names.
 */
export const mapHotspotsDesktop = [
  { id: "yoga", label: "Yoga / Zumba Studio", top: "16%", left: "16.5%", width: "15%", height: "5%" },
  { id: "supermarket", label: "Supermarket", top: "16%", left: "58.1%", width: "11.3%", height: "5%" },
  { id: "swimming", label: "Swimming Pool", top: "68.8%", left: "84.5%", width: "13%", height: "5%" },
  { id: "gymnasium", label: "Gymnasium", top: "60%", left: "15.1%", width: "11%", height: "5%" },
  { id: "basketball", label: "Basketball Court", top: "42%", left: "41.3%", width: "15%", height: "5%" },
  { id: "walking", label: "Walking / Running Track", top: "68.8%", left: "57.6%", width: "19%", height: "5%" },
  { id: "restaurants", label: "Restaurants", top: "77.5%", left: "36%", width: "12%", height: "5%" },
];

/** Portrait mobile click targets for `home-mobile.png`. */
export const mapHotspotsMobile = [
  { id: "yoga", label: "Yoga / Zumba Studio", top: "39%", left: "4%", width: "25%", height: "3.8%" },
  { id: "supermarket", label: "Supermarket", top: "13.2%", left: "61%", width: "22%", height: "3.8%" },
  { id: "swimming", label: "Swimming Pool", top: "53.2%", left: "58%", width: "26%", height: "3.8%" },
  { id: "gymnasium", label: "Gymnasium", top: "60.5%", left: "7%", width: "22%", height: "3.8%" },
  { id: "basketball", label: "Basketball Court", top: "25.2%", left: "5%", width: "26%", height: "3.8%" },
  { id: "walking", label: "Walking / Running Track", top: "33.5%", left: "60%", width: "26%", height: "5.2%" },
  { id: "restaurants", label: "Restaurants", top: "15.8%", left: "24.2%", width: "22%", height: "3.8%" },
];

/** Backward compatibility for older imports. */
export const mapHotspots = mapHotspotsDesktop;

/** Matches `unhealthy-lifestyle-php/yoga.php`: two carousel slides × 4 poses + draggable name bank. */
export const yogaData = {
  maxScore: 40,
  title: "Yoga / Zumba Studio",
  /** Legacy asset; prefer `backgroundDesktop` / `backgroundMobile` on `body`. */
  background: "/unhealthy-game/img/yoga_bg.jpg",
  backgroundDesktop: "/img/yoga-desktop-bg.png",
  backgroundMobile: "/img/yoda-mobile-bg.png",
  /** Legacy PHP copy (includes original spelling). */
  headlineLine1: "HAS SENT YOUR INSTRUCTION HOME!",
  headlineLine2:
    "CAN YOU TAKE CHARGE TO DRIVE THIS YOGA CLASS BY INDENTIFYING THE RIGHT YOGA ASANAS FOR BEGINNERS",
  subhead: "Match the Yoga Asanas with their names",
  slides: [
    { image: "/unhealthy-game/img/1.png", answer: "Mountain Pose" },
    { image: "/unhealthy-game/img/2.png", answer: "Downward-Facing Dog" },
    { image: "/unhealthy-game/img/3.png", answer: "Tree Pose" },
    { image: "/unhealthy-game/img/4.png", answer: "Warrior Poses" },
    { image: "/unhealthy-game/img/childs-pose.png", answer: "Childs Pose" },
    { image: "/unhealthy-game/img/cobra-pose.png", answer: "Cobra Pose" },
    { image: "/unhealthy-game/img/lotus-pose.png", answer: "Lotus Pose" },
    { image: "/unhealthy-game/img/triangle-pose.png", answer: "Triangle Pose" },
  ],
  /**
   * Bottom bank order matches yoga.php markup (row-major).
   * `match` is compared to slide `answer`; `label` is shown on the chip.
   */
  bankChips: [
    { match: "Warrior Poses", label: "Warrior Poses" },
    { match: "Tree Pose", label: "Tree Pose" },
    { match: "Mountain Pose", label: "Mountain Pose" },
    { match: "Downward-Facing Dog", label: "Downward-Facing Dog" },
    { match: "Cobra Pose", label: "Cobra Pose" },
    { match: "Triangle Pose", label: "Triangle Pose" },
    { match: "Childs Pose", label: "Child's Pose" },
    { match: "Lotus Pose", label: "Lotus Pose" },
  ],
};

export const restaurantsData = {
  maxScore: 5,
  title: "Restaurants",
  background: "/unhealthy-game/img/rest_bg.jpg",
  backgroundMobile: restaurantMobileBg,
  prompt:
    "In the cryptogram, decode the message and enter the exact sentence.",
  answerVariants: [
    "a diet with variety: veggies shouldn't be scary!",
    "a diet with variety: veggies shouldnt be scary!",
  ],
};

export const findStages = {
  gymnasium: {
    maxScore: 35,
    title: "Gymnasium",
    svgAsset: "/unhealthy-game/gym-desktop.svg",
    pointsPerClick: 5,
    items: [
      "Skipping_Rope",
      "Pull_up_Bar",
      "KettleBell",
      "Dumbell",
      "Medicine_Ball",
      "Resistance_Band",
      "Foam_Roller",
    ],
  },
  basketball: {
    /** 7 court lines × 5 points each */
    maxScore: 35,
    title: "Basketball Court",
    svgAsset: "/unhealthy-game/Basketball.svg",
    pointsPerClick: 5,
    items: [
      "Right_Side_Line_blur",
      "Center_Line_Blur",
      "Inside_Line_01_Blur",
      "Left_side_line_blur",
      "Inside_Line_02_blur",
      "_x34__Line_Right_Blur",
      "_x34__Line_Left_Blur",
    ],
  },
  swimming: {
    maxScore: 6,
    title: "Swimming Pool",
    svgAsset: "/unhealthy-game/updated.php",
    items: ["pool_brush", "skimmer", "vacuum", "pool_filter", "chemical", "chlorine"],
  },
};

export const walkingData = {
  maxScore: 10,
  title: "Walking / Running Track",
  instructions:
    "You want to prepare for the upcoming marathon. Weaker has placed obstacles on the running track. Use arrow keys to move the character left, right, forward, and backward.",
  durationSeconds: 65,
  background: "/unhealthy-game/images/run_bg.jpg",
};

export const supermarketData = {
  maxScore: 115,
  title: "Supermarket",
  background: "/unhealthy-game/img/market/bg.jpg",
  healthyBasket: "/unhealthy-game/img/market/26.png",
  unhealthyBasket: "/unhealthy-game/img/market/27.png",
  items: [
    { id: "03", image: "/unhealthy-game/img/market/03.png", answer: "healthy", x: 220, y: 118, w: 153, h: 41 },
    { id: "04", image: "/unhealthy-game/img/market/04.png", answer: "healthy", x: 365, y: 120, w: 150, h: 30 },
    { id: "05", image: "/unhealthy-game/img/market/05.png", answer: "unhealthy", x: 742, y: 288, w: 195, h: 21 },
    { id: "06", image: "/unhealthy-game/img/market/06.png", answer: "healthy", x: 220, y: 292, w: 90, h: 50 },
    { id: "01", image: "/unhealthy-game/img/market/01.png", answer: "healthy", x: 120, y: 246, w: 150, h: 50 },
    { id: "02", image: "/unhealthy-game/img/market/02.png", answer: "healthy", x: 170, y: 322, w: 150, h: 50 },
    { id: "23", image: "/unhealthy-game/img/market/23.png", answer: "healthy", x: 1500, y: 324, w: 150, h: 50 },
    { id: "24", image: "/unhealthy-game/img/market/24.png", answer: "healthy", x: 1540, y: 248, w: 150, h: 50 },
    { id: "25", image: "/unhealthy-game/img/market/25.png", answer: "healthy", x: 1600, y: 172, w: 150, h: 50 },
    { id: "08", image: "/unhealthy-game/img/market/08.png", answer: "healthy", x: 565, y: 118, w: 121, h: 36 },
    { id: "09", image: "/unhealthy-game/img/market/09.png", answer: "healthy", x: 742, y: 110, w: 132, h: 45 },
    { id: "10", image: "/unhealthy-game/img/market/10.png", answer: "unhealthy", x: 930, y: 124, w: 95, h: 37 },
    { id: "11", image: "/unhealthy-game/img/market/11.png", answer: "unhealthy", x: 1118, y: 126, w: 130, h: 17 },
    { id: "12", image: "/unhealthy-game/img/market/12.png", answer: "unhealthy", x: 1298, y: 108, w: 128, h: 54 },
    { id: "13", image: "/unhealthy-game/img/market/13.png", answer: "healthy", x: 560, y: 205, w: 135, h: 38 },
    { id: "14", image: "/unhealthy-game/img/market/14.png", answer: "healthy", x: 742, y: 202, w: 113, h: 46 },
    { id: "15", image: "/unhealthy-game/img/market/15.png", answer: "healthy", x: 928, y: 204, w: 95, h: 47 },
    { id: "16", image: "/unhealthy-game/img/market/16.png", answer: "unhealthy", x: 1118, y: 206, w: 77, h: 46 },
    { id: "17", image: "/unhealthy-game/img/market/17.png", answer: "unhealthy", x: 1296, y: 198, w: 150, h: 50 },
    { id: "18", image: "/unhealthy-game/img/market/18.png", answer: "healthy", x: 560, y: 292, w: 150, h: 50 },
    { id: "19", image: "/unhealthy-game/img/market/19.png", answer: "unhealthy", x: 760, y: 286, w: 150, h: 44 },
    { id: "20", image: "/unhealthy-game/img/market/20.png", answer: "unhealthy", x: 950, y: 298, w: 145, h: 22 },
    { id: "21", image: "/unhealthy-game/img/market/21.png", answer: "unhealthy", x: 1130, y: 292, w: 117, h: 33 },
  ],
};

export const STAGE_IDS = [
  "yoga",
  "restaurants",
  "gymnasium",
  "basketball",
  "swimming",
  "walking",
  "supermarket",
];

/**
 * Central stage registry used by stage pages.
 * Desktop/mobile assets are swappable without changing stage components.
 */
export const stageRegistry = {
  yoga: {
    id: "yoga",
    title: "Yoga / Zumba Studio",
    maxScore: yogaData.maxScore,
    stageType: "yoga",
    assets: {
      desktop: yogaData.backgroundDesktop || yogaData.background,
      mobile: yogaData.backgroundMobile || yogaData.background,
    },
    theme: {
      headingColor: "#ffffff",
      bodyColor: "#f2f7f2",
    },
    data: yogaData,
  },
  restaurants: {
    id: "restaurants",
    title: "Restaurants",
    maxScore: restaurantsData.maxScore,
    stageType: "restaurants",
    assets: {
      desktop: restaurantsData.background,
      mobile: restaurantsData.backgroundMobile || restaurantsData.background,
    },
    theme: {
      headingColor: "#173f16",
      bodyColor: "#173f16",
    },
    data: restaurantsData,
  },
  gymnasium: {
    id: "gymnasium",
    title: "Gymnasium",
    maxScore: findStages.gymnasium.maxScore,
    stageType: "find",
    assets: {
      desktop: "/unhealthy-game/gym-desktop.svg",
      mobile: "/unhealthy-game/gym-mobile.svg",
    },
    theme: {
      headingColor: "#0f2d41",
      bodyColor: "#17313f",
    },
    data: findStages.gymnasium,
  },
  basketball: {
    id: "basketball",
    title: "Basketball Court",
    maxScore: findStages.basketball.maxScore,
    stageType: "basketball",
    assets: {
      desktop: "/unhealthy-game/Basketball.svg",
      mobile: "/unhealthy-game/Basketball-mobile.svg",
    },
    theme: {
      headingColor: "#ffffff",
      bodyColor: "#f3f7ff",
    },
    data: findStages.basketball,
  },
  swimming: {
    id: "swimming",
    title: "Swimming Pool",
    maxScore: 30,
    stageType: "swimming",
    assets: {
      desktop: "/unhealthy-game/swimming-pool-desktop.svg",
      mobile: "/unhealthy-game/Swimming-pull-mobile.svg",
    },
    theme: {
      headingColor: "#12374a",
      bodyColor: "#183b4c",
    },
    data: {
      ...findStages.swimming,
      background: "/unhealthy-game/swimming_bg.png",
    },
  },
  walking: {
    id: "walking",
    title: "Walking / Running Track",
    maxScore: walkingData.maxScore,
    stageType: "walking",
    assets: {
      desktop: walkingData.background,
      mobile: walkingData.background,
    },
    theme: {
      headingColor: "#18360f",
      bodyColor: "#18360f",
    },
    data: walkingData,
  },
  supermarket: {
    id: "supermarket",
    title: "Supermarket",
    maxScore: supermarketData.maxScore,
    stageType: "supermarket",
    assets: {
      desktop: supermarketData.background,
      mobile: supermarketData.background,
    },
    theme: {
      headingColor: "#103f63",
      bodyColor: "#143d59",
    },
    data: supermarketData,
  },
};
